import { render, staticRenderFns } from "./voices.vue?vue&type=template&id=e2e378fa&"
import script from "./voices.vue?vue&type=script&lang=js&"
export * from "./voices.vue?vue&type=script&lang=js&"
import style0 from "./voices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports